export default __webpack_public_path__ + "static/media/sherwin.5dd30ac3.jpg";